import { useMemo } from "react";
import { ErrorBoundary } from "react-error-boundary";
import homeStyles from "../../portal.module.css";
import { error500 } from "../../shared";
import { MemoizedRosterPage } from "./roster-page";
import { Provider } from "react-redux";
import { createRosterStore } from "./store/roster-store";

export default function RosterPage() {
	const store = useMemo(createRosterStore, []);

	return (
		<ErrorBoundary fallback={<iframe className={homeStyles.iframePage} src={error500}></iframe>}>
			<Provider store={store}>
				<MemoizedRosterPage />
			</Provider>
		</ErrorBoundary>
	);
}
